<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="待收货" name="list">
      <List ref="list"/>
    </el-tab-pane>
    <el-tab-pane label="待反馈" name="history">
      <History ref="history" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List';
import History from './History';

export default {
  name: 'sample-feedback',
  components: {
    List,
    History
  },
  data() {
    return {
      activeName: 'list',
    };
  },
  watch: {
    activeName(val) {
      this.$refs[val].getList();
    },
  },
  methods: {
  },
};
</script>
